import { render, staticRenderFns } from "./EmailDone.vue?vue&type=template&id=21ebb378&lang=pug&"
import script from "./EmailDone.vue?vue&type=script&lang=ts&"
export * from "./EmailDone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports